import { c as _c } from "react/compiler-runtime";
import { AspectRatio, Box, Image, VStack } from '@chakra-ui/react';
import { useContentTrackContext } from '@src/components/sco/Education/ContentTrackContext';
import { MarkdownRenderer } from '@src/components/sco/MarkdownRenderer';
import { ViewableTracker } from '@src/components/sco/ViewableTracker';
import { Article, ContentTrackStep } from '@src/graphql-types';
import { gql } from '@src/lib/gql';
import React from 'react';
type ArticleStepProps = {
  article: Article | any;
  contentTrackStep: ContentTrackStep;
};
export const ArticleStep = props => {
  const $ = _c(13);
  const trackContext = useContentTrackContext();
  const t0 = trackContext.contentTrackEnrollment?.contentTrackEnrollmentId;
  let t1;
  if ($[0] !== props.article.featuredImage || $[1] !== props.article.title) {
    t1 = props.article.featuredImage ? <AspectRatio borderRadius="3xl" ratio={1.7777777777777777} width="full"><Image alt={props.article.title} borderRadius="3xl" boxShadow="lg" objectFit="cover" src={props.article.featuredImage.url} w="100%" /></AspectRatio> : <div />;
    $[0] = props.article.featuredImage;
    $[1] = props.article.title;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== props.article.body) {
    t2 = <Box maxWidth="container.md" width="full"><MarkdownRenderer preset="eduArticle">{props.article.body}</MarkdownRenderer></Box>;
    $[3] = props.article.body;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t1 || $[6] !== t2) {
    t3 = <VStack align="center" gap={10} width="full">{t1}{t2}</VStack>;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== props.contentTrackStep.__typename || $[9] !== props.contentTrackStep.id || $[10] !== t0 || $[11] !== t3) {
    t4 = <ViewableTracker parentId={t0} parentType="ContentTrackEnrollment" trackScrolling={true} viewableContext="article" viewableId={props.contentTrackStep.id} viewableType={props.contentTrackStep.__typename}>{t3}</ViewableTracker>;
    $[8] = props.contentTrackStep.__typename;
    $[9] = props.contentTrackStep.id;
    $[10] = t0;
    $[11] = t3;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  return t4;
};
ArticleStep.fragments = {
  Article: () => gql`
    fragment _ on Article {
      id
      title
      seoDescription
      slug
      featuredImage {
        id
        url(transformation: { image: { resize: { fit: max, width: 1000 } } })
        altText
        height
        width
      }
      body
      authors {
        id
        firstName
        lastName
        avatar {
          id
          url
        }
      }
    }
  `
};